import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UINotificationService } from '../../core/providers/ui-notification.service';
import { TranslateService } from '@ngx-translate/core';

export interface ComponentCanDeactivate {
    canDeactivateWhileWorkingProcess: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class WorkInProcessService {
  constructor(
    private notificationService: UINotificationService,
    private translator: TranslateService
  ) {}

  async confirmDeactivation(filter: boolean = false): Promise<boolean> {
    const result = await this.notificationService.showModalMessage({
      message: filter === true 
      ? this.translator.instant('UI.Common.WorkInProcess.Info.Filter|Még dolgozunk. Várj néhány másodpercet a szűréssel.') 
      : this.translator.instant('UI.Common.WorkInProcess.Info|Még dolgozunk. Várj néhány másodpercet a kilépéssel.'),
      buttons: ['ok'],
      buttonBgColor: ['#2196f3'],
      buttonColor: ['#fff'],
      type: 'warning',
      panelClasses: 'work-in-process-popup'
    });

    return true;
  }
}

@Injectable()
export class WorkInProcessGuard {
    constructor(private workInProcessService: WorkInProcessService) {
    }
    canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> {
      if (component.canDeactivateWhileWorkingProcess()) {
        return true;
      } else {
  
        return this.workInProcessService.confirmDeactivation();        
      }
    }
}
